module.exports = "/_next/static/resources/array-dec91ef622b58186f9ea72abecb6b7e2.jpg";